// fileRef 自定义节点(D10:只存 uuid,绝不存 url / thumb 地址)。
//
// content(ProseMirror JSON)里的文件嵌入节点只携带 `fileId`(uuid)。详情渲染层
// (article-render.tsx)收集全部 fileId → 批量 `get_public_files(ids)` 运行时解析为
// 元数据 + 签名 thumb + 跳转链接。编辑器内只渲染占位卡(NodeView)。
//
// parseHTML / renderHTML 走 data-file-id 属性,保证序列化往返只保留 uuid。

import { Node, mergeAttributes } from '@tiptap/core'

export type FileRefAttrs = {
  fileId: string | null
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    fileRef: {
      /** 在当前位置批量插入 fileRef 节点(只存 fileId uuid)。 */
      insertFileRefs: (fileIds: string[]) => ReturnType
    }
  }
}

export const FileRefNode = Node.create({
  name: 'fileRef',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      fileId: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-file-id'),
        renderHTML: (attributes) => {
          const attrs = attributes as FileRefAttrs
          if (!attrs.fileId) return {}
          return { 'data-file-id': attrs.fileId }
        },
      },
    }
  },

  parseHTML() {
    return [{ tag: 'div[data-file-ref]' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes({ 'data-file-ref': '' }, HTMLAttributes)]
  },

  addCommands() {
    return {
      // 必须单次 insertContent 批量插入:atom+selectable 节点插入后选区变成该节点的
      // NodeSelection,循环逐个插入会把上一个节点替换掉,多选只剩最后一个。
      insertFileRefs:
        (fileIds: string[]) =>
        ({ commands }) => {
          if (fileIds.length === 0) return true
          // 末尾追加空段落:atom 节点收尾时选区会停在其 NodeSelection 上,后续
          // 任何插入/输入都会替换它;以段落收尾则光标落在段落内(文本选区),
          // 且下次向空段落插入时 tiptap 会整体替换该空段落,不会累积空行。
          return commands.insertContent([
            ...fileIds.map((fileId) => ({ type: this.name, attrs: { fileId } })),
            { type: 'paragraph' },
          ])
        },
    }
  },
})
